//========== Services Section ==========

import { useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTools } from "@fortawesome/free-solid-svg-icons";
import { services } from "../../js/servicesData";
import "./services.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const ServicesSection = () => {
  const ref = useRef(null);
  useEffect(() => {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
        } else {
          entry.target.classList.remove("visible");
        }
      });
    }, {
      root: null,
      rootMargin: "0px",
      threshold: 0.8
    });
    const elements = ref.current.querySelectorAll(".service-item-inner");
    elements.forEach(element => {
      observer.observe(element);
    });
    return () => {
      elements.forEach(element => {
        observer.unobserve(element);
      });
    };
  }, []);
  return /*#__PURE__*/_jsx("section", {
    id: "services",
    className: "service section",
    ref: ref,
    children: /*#__PURE__*/_jsxs("div", {
      className: "container",
      children: [/*#__PURE__*/_jsx("div", {
        className: "row",
        children: /*#__PURE__*/_jsx("div", {
          className: "section-title padd-15",
          children: /*#__PURE__*/_jsxs("h2", {
            children: [/*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: faTools
            }), /*#__PURE__*/_jsx("span", {
              className: "servicesSpan",
              children: " Our"
            }), " Services"]
          })
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "row",
        children: services.map(service => /*#__PURE__*/_jsx("div", {
          className: "col-md-4 col-sm-6 service-item padd-15",
          children: /*#__PURE__*/_jsxs("div", {
            className: "service-item-inner pt-4",
            children: [/*#__PURE__*/_jsx("div", {
              className: "icon",
              children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
                icon: service.icon,
                size: "3x"
              })
            }), /*#__PURE__*/_jsx("h4", {
              children: service.title
            }), /*#__PURE__*/_jsx("p", {
              children: service.description
            })]
          })
        }, service.title))
      })]
    })
  });
};
export default ServicesSection;